import React from 'react'
import { home } from '../../app/routes';

import Modal from '../../common/Modal';
import Link from '../../common/Link';
import FormButton from '../../forms/FormButton';

import styles from './index.module.css'

const SuccessArrangementModal = ({ isOpen, data }) => {
  const fakeCloseModal = () => {};

  return (
    <Modal modalClassName={styles.modal} isOpen={isOpen} onClose={fakeCloseModal}>
      <div className={styles.wrapper}>
        <h3 className={styles.title}>
          Payment arrangement requested successfully
        </h3>
        <p className={styles.subtitle}>Request details</p>
        <ul className={styles.list}>
          <li>Purchase ID: #{data.purchaseId}</li>
          <li>Amount to Pay: ${data.total}</li>
          <li>Date to Pay: {data.date}</li>
          <li>Card to Charge: **** {data.cardLastFour}</li>
        </ul>
        <p className={styles.subtitle}><b>You will receive an email regarding the status of your request within 24-48 hours.</b></p>
        <Link to={home()}>
          <FormButton className={styles.button}>
            Back Home
          </FormButton>
        </Link>
      </div>
    </Modal>
  )
}

export default SuccessArrangementModal
